import * as http from './config'

/**
 * 获取售后预约列表(index查询)
 * @param {int} pageSize 显示行数
 * @param {int} pageIndex 页码
 */
export const getBoardSignList = (search,pageSize,pageIndex) => {
  let searchData = {
    OrderNo: search.search,
    CaseName: search.search,
    SignLegalUserID: search.SignLegalUserID,
    SignLegalUserName: search.SignLegalUserName,
    CityCode: search.CityCode,
    Status: search.Status,
    StartDate: search.startDate,
    EndDate: search.endDate
  };
  let pageModel = {
    PageSize: pageSize,
    PageIndex: pageIndex,
  }
  return http.get('api/Board/GetBoardSignList',{...searchData,...pageModel});
}

/**
 * 通过城市code获取业务类型
 * @param {string} city 城市code
 */
export const GetBusinessTypeList = (city) => {
  return http.get('api/Board/GetBusinessTypeList',{city});
}

/**
 * 售后预约取消
 * @param {string} id id
 */
export const CancelAppointment = (id) => {
  return http.get('api/Board/CancelAppointment',{id});
}

/**
 * 获取案件实体
 * @param {string} id ID
 */
export const getBoardSignInfoById = (id) => {
  return http.get('api/Board/GetBoardSignInfoById',{id});
}

/**
 * 获取案件实体
 * @param {string} orderNo 委托编号
 */
export const getBoardSignInfo = (orderNo) => {
  return http.get('api/Board/GetBoardSignInfo',{orderNo});
}

/**
 * 判断案件是否可被售后预约
 * @param {string} orderNo 委托编号
 */
export const judgeCaseCanSign = (orderNo) => {
  return http.get('api/Board/JudgeCaseCanSign',{orderNo});
}

/**
 * 售后预约处理
 * @param {object} entity 实体
 */
export const dealBoardSign = (entity) => {
  return http.post('api/Board/DealBoardSign',entity);
}

/**
 * 判断是否可以售后预约
 * @param {string} date 预约日期
 * @param {string} signCenter 签约中心
 * @param {string} doType 预约事件类型
 * @param {string} areaCode 区code
 */
export const judgeCanSign = (entity) => {
  let date = entity.AppointmentDateTime,
  signCenter = entity.SignCenterCode,
  doType = entity.DoType,
  areaCode = entity.AppointmentDistrictCode;
  return http.get('api/Board/JudgeCanSign',{date, signCenter, doType, areaCode});
}

/**
 * 创建业务售后预约
 * @param {object} entity 实体
 */
export const createBoardSignInfo = (entity) => {
  return http.post('api/Board/CreateBoardSignInfo',entity);
}

/**
 * 修改业务售后预约
 * @param {object} entity 实体
 */
export const updateBoardSignInfo = (entity) => {
  return http.post('api/Board/UpdateBoardSignInfo',entity);
}

/**
 * 获取售后预约列表(index页日历版)
 * @param {int} year 年
 * @param {int} month 月
 * @param {string} domain 城市
 */
export const getBoardSignListForIndexCalendar = (year,month,domain) => {
  return http.get('api/Board/GetBoardSignListForCalendar',{year,month,domain});
}